import { render, staticRenderFns } from "./volume-variant.vue?vue&type=template&id=3cb8b84b"
import script from "./volume-variant.vue?vue&type=script&lang=js"
export * from "./volume-variant.vue?vue&type=script&lang=js"
import style0 from "./volume-variant.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports